import React, { Component } from 'react';
import TextField from 'material-ui/TextField';

import theme from '../../../muiTheme.js';

class TextFilter extends Component {


  handleChange = (e) => {
    this.props.onChange(e.target.value);
  }

  render() {

    const textFileStyle = {
      inputStyle: {
        color: theme.palette.canvasColor
      },
      floatingLabelStyle: {
        color: theme.palette.secondaryTextColor
      },
      floatingLabelFocusStyle: {
        color: theme.palette.canvasColor
      }
    };

    return (
      <div className="filter-item filter-item-text-field">
        <TextField
          fullWidth={true}
          value={this.props.value || ""}
          floatingLabelText={this.props.label}
          floatingLabelStyle={textFileStyle.floatingLabelStyle}
          floatingLabelFocusStyle={textFileStyle.floatingLabelFocusStyle}
          inputStyle={textFileStyle.inputStyle}
          onChange={this.handleChange}
          />
      </div>
    );
  }

}

export default TextFilter;
